import {createSlice} from '@reduxjs/toolkit';
import {
  createCategory,
  createVendor,
  deleteCategory,
  deleteDrugInventory,
  deleteVendor,
  getCategories,
  getDrugInventory,
  getVendors,
  updateCategory,
  updateDrugInventory,
  updateVendor
} from '../Thunk/drugInventoryActions';

const drugInventorySlice = createSlice({
  name: 'drugInventory',
  initialState: {
    drugInventory: [],
    drugInventoryCount: 0,
    categories: [],
    vendors: [],
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      // Fetch Drug Inventory
      .addCase(getDrugInventory.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDrugInventory.fulfilled, (state, action) => {
        state.loading = false;
        state.drugInventory = action.payload?.data ?? [];
        state.drugInventoryCount = action.payload?.total_count ?? state.drugInventory.length;
      })
      .addCase(getDrugInventory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to fetch drug inventory';
      })

      // Fetch Drug Categories
      .addCase(getCategories.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload?.data ?? [];
      })
      .addCase(getCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to fetch categories';
      })

      .addCase(createCategory.pending, state => {
        state.loading = true;
      })
      .addCase(createCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.categories.push(action.payload);
      })
      .addCase(createCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to create categories';
      })

      .addCase(updateCategory.pending, state => {
        state.loading = true;
      })
      .addCase(updateCategory.fulfilled, (state, action) => {
        state.loading = false;
        if (!action.payload || !action.payload.id) return; // Ensure valid data

        const index = state.categories.findIndex(item => item.id === action.payload.id);
        if (index !== -1) {
          state.categories[index] = action.payload; // Update item
        }
      })
      .addCase(updateCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to update Category';
      })

      .addCase(deleteCategory.pending, state => {
        state.loading = true;
      })
      .addCase(deleteCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = state.categories.filter(
          category => category.id !== action.payload.id // Remove deleted item
        );
      })
      .addCase(deleteCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to delete Category';
      })

      .addCase(getVendors.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getVendors.fulfilled, (state, action) => {
        state.loading = false;
        state.vendors = action.payload?.data ?? [];
      })
      .addCase(getVendors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to fetch Vendor';
      })

      .addCase(createVendor.pending, state => {
        state.loading = true;
      })
      .addCase(createVendor.fulfilled, (state, action) => {
        state.loading = false;
        state.vendors.push(action.payload);
      })
      .addCase(createVendor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to create Vendor';
      })

      .addCase(updateVendor.pending, state => {
        state.loading = true;
      })
      .addCase(updateVendor.fulfilled, (state, action) => {
        state.loading = false;
        if (!action.payload || !action.payload.id) return; // Ensure valid data

        const index = state.vendors.findIndex(item => item.id === action.payload.id);
        if (index !== -1) {
          state.vendors[index] = action.payload; // Update item
        }
      })
      .addCase(updateVendor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to update Vendor';
      })

      .addCase(deleteVendor.pending, state => {
        state.loading = true;
      })
      .addCase(deleteVendor.fulfilled, (state, action) => {
        state.loading = false;
        state.vendors = state.vendors.filter(
          vendor => vendor.id !== action.payload.id // Remove deleted item
        );
      })
      .addCase(deleteVendor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to delete Vendor';
      })

      .addCase(updateDrugInventory.pending, state => {
        state.loading = true;
      })
      .addCase(updateDrugInventory.fulfilled, (state, action) => {
        state.loading = false;
        if (!action.payload || !action.payload.id) return; // Ensure valid data

        const index = state.drugInventory.findIndex(item => item.id === action.payload.id);
        if (index !== -1) {
          state.drugInventory[index] = action.payload; // Update item
        }
      })
      .addCase(updateDrugInventory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to update drug inventory';
      })

      // Delete Drug Inventory (Fix applied)
      .addCase(deleteDrugInventory.pending, state => {
        state.loading = true;
      })
      .addCase(deleteDrugInventory.fulfilled, (state, action) => {
        state.loading = false;
        if (!action.payload || !action.payload.id) return; // Ensure valid ID before filtering

        state.drugInventory = state.drugInventory.filter(
          drug => drug.id !== action.payload.id // Remove deleted item
        );
      })
      .addCase(deleteDrugInventory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to delete drug inventory';
      });
  }
});

export default drugInventorySlice.reducer;
export const getAllDrugInventory = state => state.drugInventory?.drugInventory || [];
